import React from "react";

const PAGE_TITLE = "Blockset";

const useTitle = () => {
  const documentDefined = typeof document !== "undefined";
  const originalTitle = React.useRef(documentDefined ? PAGE_TITLE : null);

  React.useEffect(() => {
    if (!documentDefined) return;

    if (document.title !== PAGE_TITLE) document.title = PAGE_TITLE;

    return () => {
      document.title = originalTitle.current;
    };
  }, []);
};
export default useTitle;
